<template>
  <v-app-bar
      app
      fixed
      clipped-left
      flat
      dark
      :color="color"
      extension-height="56px"
  >
    <slot name="backButton" v-if="showBackButton">
      <v-btn 
        icon
        class="ml-2 mr-2"
        @click="$router.go(-1)"
        aria-label="go back">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </slot>

    <v-app-bar-nav-icon
      v-if="showNavIcon && !showBackButton"
      @click.stop="$eventHub.$emit('toggleNavigationDrawer')"
      class="ml-2 mr-2"
      aria-label="Toggle navigation menu"
    />

    <router-link to="/" style="text-decoration: none; color: inherit;" aria-label="Home">
      <v-toolbar-title class="pl-0">
        <slot name="appIcon"/>
      </v-toolbar-title>
    </router-link>

    <slot name="title">
      <router-link to="/" style="text-decoration: none; color: inherit;" aria-label="Home">
        <v-toolbar-title class="pl-0">
          <span
              class="ml-0 pl-2 mr-5 mb-4"
              style="vertical-align: middle; line-height: 40px;">
            <span style="font-weight: bold;">{{title}}</span>
          </span>
        </v-toolbar-title>
      </router-link>
    </slot>

    <v-spacer id="appBarSpacer"/>

    <div class="mr-2" id="dataSwitcherContainer">
      <slot name="dataSwitcher"/>
    </div>

    <v-toolbar-title v-if="showFullScreen">
      <FullScreen/>
    </v-toolbar-title>

    <div class="mr-2">
      <slot name="myEssentials"/>
    </div>

    <div class="mr-6">
      <slot name="profile"/>
    </div>

    <template v-slot:extension v-if="extended">
      <slot name="extension" />
    </template>
  </v-app-bar>
</template>

<script>
  import FullScreen from "../FullScreen";

  export default {
    name: "AppBar",
    components: {
      FullScreen
    },
    props: {
      color: {
        type: String,
        default: "#0A1F40"
      },
      title: String,
      showFullScreen: Boolean,
      showNavIcon: {
        type: Boolean,
        default: true
      },
      showBackButton: Boolean,
      extended: Boolean
    },
    data() {
      return {
        searchString: "",
        showSearch: false,
      }
    },
  };
</script>

<style scoped>
  ::v-deep .v-toolbar__content, ::v-deep .v-toolbar__extension {
    padding: 0px;
  }

  ::v-deep #schoolPickerContainer .v-input__control .v-input__slot {
    background-color: #1A3B69;
  }
</style>
